import { connect } from 'react-redux';
import { QueryParamsType } from '../../../state/reducers/queryParams.types';

const mapState = ({ queryParams }: { queryParams: QueryParamsType }) => ({
  originalQueryKey: queryParams.originalQueryKey,
});

export const Connect = connect(mapState);
